module.exports = __webpack_public_path__ + "static/media/0_2020_02_19.0c8a5fc3.jpg";